import isAuthenticated, { isSugarAuthorized } from "@/middleware3/auth";
import { checkUserRole } from "@/middleware3/auth";

//function page(path)
//{
//  return () => import(/* webpackChunkName: '' */ `~/pages/${path}`).then(m => m.default || m)
//}

const routes = [
  {
    path: "/",
    name: "welcome",
    component: () => import("@/pages/welcome.vue"),
  },

  {
    path: "/panel/login",
    name: "login",
    meta: { title: "log_in" },
    component: () => import("@/pages/auth/login.vue"),
  },

  {
    path: "/panel/profile",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        name: "user.profile",
        path: "",
        meta: { title: "user_profile" },
        component: () =>
          import(/* webpackChunkName: "Home" */ "@/pages/user/profile.vue"),
      },
    ],
  },

  {
    path: "/panel/locations",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "locations",
        meta: { title: "locations", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/locations/index.vue"),
      },
      {
        path: "add",
        name: "locations.add",
        meta: { title: "add_location", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/locations/add.vue"),
      },
      {
        path: ":id/edit",
        name: "locations.edit",
        meta: { title: "edit_location", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/locations/add.vue"),
      },
    ],
  },

  {
    path: "/panel/activities",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "activities",
        meta: { title: "activities", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/activities/index.vue"),
      },
      {
        path: "add",
        name: "activities.add",
        meta: { title: "add_activity", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/activities/add.vue"),
      },
      {
        path: ":id/edit",
        name: "activities.edit",
        meta: { title: "edit_activity", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/activities/add.vue"),
      },
    ],
  },

  {
    path: "/panel/activity_descriptions",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [checkUserRole("superadmin")] },
    children: [
      {
        path: "",
        name: "activity_descriptions",
        meta: { title: "activity_descriptions" },
        component: () => import("@/pages/activity_descriptions/index.vue"),
      },
    ],
  },

  {
    path: "/panel/sugar_key_users",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [checkUserRole("admin")] },
    children: [
      {
        path: "",
        name: "sugar_key_users",
        meta: { title: "sugar_key_users" },
        component: () => import("@/pages/sugar_key_users/index.vue"),
      },
    ],
  },

  {
    path: "/panel/countries",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "countries",
        meta: { title: "countries", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/countries/index.vue"),
      },
      {
        path: "add",
        name: "countries.add",
        meta: { title: "add_country", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/countries/add.vue"),
      },
      {
        path: ":id/edit",
        name: "countries.edit",
        meta: { title: "edit_country", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/countries/add.vue"),
      },
    ],
  },

  {
    path: "/panel/companies",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "companies",
        meta: { title: "companies", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/companies/index.vue"),
      },
      {
        path: "add",
        name: "companies.add",
        meta: { title: "add_company", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/companies/add.vue"),
      },
      {
        path: ":id/edit",
        name: "companies.edit",
        meta: { title: "edit_company", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/companies/add.vue"),
      },
    ],
  },

  {
    path: "/panel/ous",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "organizations",
        meta: {
          title: "og",
          middleware: [checkUserRole("admin")],
        },
        component: () =>
          import("@/pages/organizational_units/groups/index.vue"),
      },
      {
        path: ":id",
        name: "organizations.planner",
        meta: { title: "og", middleware: [checkUserRole("plannerManager")] },
        component: () =>
          import("@/pages/organizational_units/single_planner.vue"),
      },
      {
        path: "add",
        name: "organizations.add",
        meta: {
          title: "create_og",
          middleware: [checkUserRole("teamManager")],
        },
        component: () => import("@/pages/organizational_units/groups/add.vue"),
      },
      {
        path: ":id/edit",
        name: "organizations.edit",
        meta: {
          title: "edit_og",
          middleware: [checkUserRole("teamManager")],
        },
        component: () => import("@/pages/organizational_units/groups/add.vue"),
      },
    ],
  },
  {
    path: "/panel/opportunities",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isSugarAuthorized] },
    children: [
      {
        path: "",
        name: "sugar",
        meta: { title: "crm_opportunities" },
        component: () => import("@/pages/sugar_opportunities/index.vue"),
      },
    ],
  },
  {
    path: "/panel/projects",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "projects",
        meta: {
          title: "projects",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/projects/index.vue"),
      },
      {
        path: "add",
        name: "projects.add",
        meta: {
          title: "add_project",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/projects/add.vue"),
      },
      {
        path: ":id/edit",
        name: "projects.edit",
        meta: {
          title: "edit_project",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/projects/add.vue"),
      },
      {
        path: ":id/budget",
        name: "projects.budget",
        meta: {
          title: "edit_budget",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/projects/budget.vue"),
      },
      {
        path: ":id/progress",
        name: "projects.progress",
        meta: {
          title: "edit_progress",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/projects/progress.vue"),
      },
      {
        path: ":id/erlos",
        name: "projects.erlos",
        meta: {
          title: "edit_erlöse",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/projects/erlos.vue"),
      },
      {
        path: ":id/booked/:uid",
        name: "projects.user_hours",
        meta: {
          title: "user_hours",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/projects/user_hours.vue"),
      },

      {
        path: ":id",
        name: "projects.single",
        meta: {
          title: "single_project",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/projects/single.vue"),
      },
    ],
  },

  {
    path: "/panel/professions",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "professions",
        meta: { title: "professions", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/professions/index.vue"),
      },
      {
        path: "add",
        name: "professions.add",
        meta: { title: "add_profession", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/professions/add.vue"),
      },
      {
        path: ":id/edit",
        name: "professions.edit",
        meta: {
          title: "edit_profession",
          middleware: [checkUserRole("admin")],
        },
        component: () => import("@/pages/professions/add.vue"),
      },
    ],
  },

  {
    path: "/panel/ufg",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "ufg",
        meta: {
          title: "user_functional_groups",
          middleware: [checkUserRole("admin")],
        },
        component: () => import("@/pages/ufg/index.vue"),
      },
      {
        path: "add",
        name: "ufg.add",
        meta: {
          title: "add_user_functional_group",
          middleware: [checkUserRole("admin")],
        },
        component: () => import("@/pages/ufg/add.vue"),
      },
      {
        path: ":id/edit",
        name: "ufg.edit",
        meta: {
          title: "edit_user_functional_group",
          middleware: [checkUserRole("admin")],
        },
        component: () => import("@/pages/ufg/add.vue"),
      },
    ],
  },

  {
    path: "/panel/billing-ous",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "billing_ous",
        meta: {
          title: "billing_ous",
          middleware: [checkUserRole("teamManager")],
        },
        component: () => import("@/pages/reports/billing-ous/index.vue"),
      },
      {
        path: "add",
        name: "billing_ous.add",
        meta: {
          title: "create_billing_ou",
          middleware: [checkUserRole("teamManager")],
        },
        component: () => import("@/pages/reports/billing-ous/add.vue"),
      },
      {
        path: ":id/edit",
        name: "billing_ous.edit",
        meta: {
          title: "edit_billing_ou",
          middleware: [checkUserRole("teamManager")],
        },
        component: () => import("@/pages/reports/billing-ous/add.vue"),
      },
    ],
  },
  {
    path: "/panel/dashboard",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "my",
        name: "dashboard.my",
        meta: {
          title: "dashboard",
        },
        component: () => import("@/pages/dashboard/my_index.vue"),
      },
    ]
  },
  {
    path: "/panel/ou",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "organizational_units",
        meta: {
          title: "organizational_units",
          middleware: [checkUserRole("admin")],
        },
        component: () => import("@/pages/organizational_units/index.vue"),
      },
      {
        path: "my",
        name: "organizational_units.my",
        meta: {
          title: "organizational_units",
          middleware: [checkUserRole("teamManager")],
        },
        component: () => import("@/pages/organizational_units/my_index.vue"),
      },
      {
        path: "add",
        name: "organizational_units.add",
        meta: {
          title: "add_organizational_unit",
          middleware: [checkUserRole("admin")],
        },
        component: () => import("@/pages/organizational_units/add.vue"),
      },
      {
        path: ":id",
        name: "organizational_units.single",
        meta: {
          title: "single_organizational_unit",
          middleware: [checkUserRole("teamManager")],
        },
        component: () => import("@/pages/organizational_units/single.vue"),
      },
      // {
      //   path: ":id",
      //   name: "organizational_units.multiple",
      //   meta: {
      //     title: "multiple_organizational_unit",
      //     middleware: [checkUserRole("teamManager")],
      //   },
      //   component: () => import("@/pages/organizational_units/multiple.vue"),
      // },
      {
        path: ":id/edit",
        name: "organizational_units.edit",
        meta: { title: "edit_organizational_unit" },
        component: () => import("@/pages/organizational_units/add.vue"),
      },
      {
        path: ":oid/user/:uid/bookings", //todo route booked? user?
        name: "organizational_units.user_hours",
        meta: {
          title: "organizational_unit_user_booked_hours",
          middleware: [checkUserRole("teamManager")],
        },
        component: () => import("@/pages/organizational_units/user_hours.vue"),
      },
    ],
  },

  {
    path: "/panel/users",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "users",
        meta: { title: "users", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/users/index.vue"),
      },
      {
        path: "add",
        name: "users.add",
        meta: { title: "add_user", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/users/add.vue"),
      },
      {
        path: ":id/edit",
        name: "users.edit",
        meta: { title: "edit_user", middleware: [checkUserRole("admin")] },
        component: () => import("@/pages/users/add.vue"),
      },
    ],
  },

  {
    path: "/panel/holidays",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "holidays",
        meta: {
          title: "upload_holidays",
          middleware: [checkUserRole("admin")],
        },
        component: () => import("@/pages/uploads/holidays.vue"),
      },
    ],
  },

  {
    path: "/panel/export",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "export.index",
        meta: { title: "export" },
        component: () => import("@/pages/export/index.vue"),
      },
      {
        path: "add",
        name: "export.add",
        meta: { title: "export" },
        component: () => import("@/pages/export/add.vue"),
      },
      {
        path: ":id",
        name: "export.single",
        meta: { title: "export" },
        component: () => import("@/pages/export/add.vue"),
      },
    ],
  },

  {
    path: "/panel/personal",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "personal_report.index",
        meta: { title: "export", middleware: [checkUserRole("user")] },
        component: () => import("@/pages/export/personal.vue"),
      },
    ],
  },

  {
    path: "/panel/reports",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "reports",
        meta: {
          title: "export",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/reports/index.vue"),
      },
      {
        path: "matrix",
        name: "reports.matrix",
        meta: {
          title: "matrix_report",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/reports/matrix/index.vue"),
      },
      {
        path: "billing-sheets",
        name: "reports.billing_sheets",
        meta: { title: "billing_sheets" },
        component: () => import("@/pages/reports/billing-sheets/index.vue"),
      },
      {
        path: "projects-employees",
        name: "reports.projects_employees",
        meta: {
          title: "projects_employees",
          middleware: [checkUserRole("projectManager")],
        },
        component: () => import("@/pages/reports/projects-employees/index.vue"),
      },
      {
        path: "organization-projects",
        name: "reports.organization_projects",
        meta: {
          title: "projects_area",
          middleware: [checkUserRole("projectManager")],
        },
        component: () =>
          import("@/pages/reports/organization-projects/index.vue"),
      },
      {
        path: "projects-leaders",
        name: "reports.projects_leader",
        meta: {
          title: "projects_leader",
          middleware: [checkUserRole("admin")],
        },
        component: () =>
          import("@/pages/reports/projects-leader/index.vue"),
      },
      {
        path: "project-controlling",
        name: "reports.project_controlling",
        meta: {
          title: "projects_controlling",
          middleware: [checkUserRole("projectManager")],
        },
        component: () =>
          import("@/pages/reports/project-controlling/index.vue"),
      },
    ],
  },

  {
    path: "/panel/booking/book",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "/panel/booking/book",
        name: "booking.add",
        meta: { title: "add_time_booking" },
        component: () => import("@/pages/booking/add.vue"),
      },
    ],
  },

  {
    path: "/panel/booking/book/user/:uid",
    component: () => import("@/layouts/default.vue"),
    meta: { middleware: [isAuthenticated] },
    children: [
      {
        path: "",
        name: "booking.add_for",
        meta: { title: "add_time_booking_for" },
        component: () => import("@/pages/booking/add_for.vue"),
      },
    ],
  },

  // Uncaught Error: Catch all routes ("*") must now be defined using a param with a custom regexp.
  // { path: '*', component: import('@/pages/errors/404.vue') }
];

export default routes;
